import { ButtonLink } from '../components/ui'
import { RegisterButton } from '../components/race'

export function NotFound() {
  return (
    <div className="container-page flex flex-col items-start gap-5 py-24">
      <p className="eyebrow">Off course</p>
      <h1 className="display text-6xl">This page took a wrong turn</h1>
      <p className="max-w-prose text-lg text-ink-2">The link may be old or mistyped. Head back to the start line and try again.</p>
      <div className="flex flex-wrap gap-3">
        <ButtonLink to="/">Back to the home page</ButtonLink>
        <RegisterButton variant="secondary">
          Register
        </RegisterButton>
      </div>
    </div>
  )
}
